import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { appRouteLayout, AppRouteLayout } from './app-route-layout';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  public readonly sceneOnly$: Observable<boolean>;
  public readonly viewerMode$: Observable<boolean>;
  /** Full-bleed pages that scroll as a document, such as the showcase index and the help page. */
  public readonly scrollableMode$: Observable<boolean>;

  constructor(router: Router) {
    const routePath$: Observable<string> = router.events.pipe(
      filter((event: unknown) => event instanceof NavigationEnd),
      startWith(null),
      map(
        () =>
          router
            .parseUrl(router.url)
            .root.children['primary']?.segments.map((segment: UrlSegment) => segment.path)
            .join('/') ?? ''
      ),
      distinctUntilChanged()
    );
    const layout$: Observable<AppRouteLayout> = routePath$.pipe(map(appRouteLayout));
    this.sceneOnly$ = layout$.pipe(map((layout: AppRouteLayout) => layout.sceneOnly));
    this.viewerMode$ = layout$.pipe(map((layout: AppRouteLayout) => layout.fullBleed));
    this.scrollableMode$ = layout$.pipe(map((layout: AppRouteLayout) => layout.scrollable));
  }
}
